<div class="page-content" *ngIf="!timerService.isForwarding">
  <div>
    <button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>
      {{ Button.Previous }}
    </button>
  </div>

  <h1 class="page-title" translate>
    {{ "before_you_begin.page_title" }}
  </h1>

  <div translate>
    {{ "before_you_begin.instruction-text1" }}
  </div>

  <div class="accordion-padding">
    <accordion header="before_you_begin.accordion1.header" translate>
      <ul>
        <li>
          <span  translate>
            {{ "before_you_begin.accordion1.name-of-child" }}
          </span>
        </li>
        <li>
          <span  translate>
            {{ "before_you_begin.accordion1.dob-birthplace" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion1.hospital-name" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion1.gender-birth-weight" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion1.doctor-or-midwife" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion1.parent-info" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion1.caregiver_sin_text1" | translate }}
            <a
              href="{{ 'before_you_begin.accordion1.caregiver_sin_link' | translate }}"
              title="{{'before_you_begin.accordion1.caregiver_sin_link_title' | translate}}"
              target="_blank"
              >{{ "before_you_begin.accordion1.caregiver_sin_text2" | translate }}</a
            >
            {{ "before_you_begin.accordion1.caregiver_sin_text3" | translate }}
          </span>
        </li>
      </ul>
    </accordion>
  </div>
  <div class="accordion-padding">
    <accordion header="before_you_begin.accordion2.header">
        {{ "before_you_begin.accordion2.support_doc_text1" | translate }}
        <a routerLink="/{{ orgContactPath }}" href="#" title="{{'before_you_begin.accordion2.support_doc_ORG_link_title' | translate}}">{{
          "before_you_begin.accordion2.support_doc_text2" | translate
        }}</a>
        {{ "before_you_begin.accordion2.support_doc_text3" | translate }}
      <ul>
        <li>
          <span translate>
            {{ "before_you_begin.accordion2.surrogacy" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion2.other_person" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion2.parent_nocertify" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion2.parent_nocert_illness" }}
          </span>
        </li>
        <li>
          <span translate>
            {{ "before_you_begin.accordion2.child_single_name" }}
          </span>
        </li>
      </ul>
      <div [innerHTML]="'before_you_begin.accordion2.detailed_instructions' | translate"></div>
    </accordion>
  </div>
  <div translate class="padding-top-1em">
    {{ "before_you_begin.page-description1" }}
  </div>

  <div translate class="padding-top-1em">
    {{ "before_you_begin.text-does-not-apply" }}
  </div>
  <ul>
    <li>
      <span translate>
        {{"before_you_begin.instruction-bullet1"}}
      </span>
    </li>

    <li>
      <span translate>
        {{ "before_you_begin.instruction-bullet2" }}
      </span>
    </li>
  </ul>
  <div translate>
    {{ "before_you_begin.instruction-duration" }}
  </div>

  <div translate class="padding-top-1em">
    {{ "before_you_begin.instruction-session" }}
  </div>

  <div class="btn-div">
    <button class="btn-next" title="{{Button.START_alt | translate}}" (click)="onNextClick()" translate>
        {{Button.START}}
    </button>
  </div>
</div>
